import { createFileRoute } from "@tanstack/react-router";
import { AdminPage } from "@/components/admin/AdminSidebar";
import { ArticulosPanel } from "@/components/admin/ArticulosPanel";

export const Route = createFileRoute("/admin/publicaciones")({
  component: () => (
    <AdminPage
      title="Publicaciones"
      description="Artículos de Bizaclia News. Portada desde Unsplash, slug y SEO."
    >
      <ArticulosPanel />
    </AdminPage>
  ),
});
